import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { colors } from "../../../../../../theme/muiColors";
import { useState } from "react";

import CancelIcon from "@mui/icons-material/Cancel";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import RefreshIcon from "@mui/icons-material/Refresh";
import ReplayIcon from "@mui/icons-material/Replay";
import SendIcon from "@mui/icons-material/Send";

export const InvoiceActionsMenu = ({
  invoiceStatus,
  hasPayPalPending,
  isEditable,
  canRefund,
  canCancel,
  isSyncingPayment,
  isResendPending,
  isResendCoolingDown,
  resendRemainingSec,
  isRefundPending,
  isCancelPending,
  invoiceUid,
  handleVerifyPaymentStatus,
  handleResendClick,
  handleRefundClick,
  handleCancelClick,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleOpen} size="small" sx={{ backgroundColor: colors.grey[100], "&:hover": { backgroundColor: colors.grey[300] } }}>
        <MoreVertIcon />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {invoiceStatus === "UNPAID" && hasPayPalPending && (
          <MenuItem
            onClick={() => {
              handleVerifyPaymentStatus();
              handleClose();
            }}
            disabled={isSyncingPayment}
          >
            <ListItemIcon>
              <RefreshIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{isSyncingPayment ? "Checking…" : "Verify payment status"}</ListItemText>
          </MenuItem>
        )}

        {isEditable && (
          <MenuItem
            onClick={() => {
              handleResendClick();
              handleClose();
            }}
            disabled={isResendPending || isResendCoolingDown}
          >
            <ListItemIcon>
              <SendIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{isResendPending ? "Sending…" : isResendCoolingDown ? `Resend in ${resendRemainingSec}s` : "Resend Invoice"}</ListItemText>
          </MenuItem>
        )}

        {canRefund && (
          <MenuItem
            onClick={() => {
              handleRefundClick();
              handleClose();
            }}
            disabled={isRefundPending}
          >
            <ListItemIcon>
              <ReplayIcon fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText primary="Refund" />
          </MenuItem>
        )}

        {canCancel && (
          <MenuItem
            onClick={() => {
              handleCancelClick();
              handleClose();
            }}
            disabled={isCancelPending}
          >
            <ListItemIcon>
              <CancelIcon fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText primary="Cancel Invoice" />
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            window.open(`/invoices/${invoiceUid}`, "_blank");
            handleClose();
          }}
        >
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Client View (PDF)" />
        </MenuItem>
      </Menu>
    </>
  );
};
